import React, { useState, useEffect } from "react";

import Table from "components/table";
import ActionPanel from "./actionPanel";
import { useHeader } from "components/header/store";
import { Container } from "./styles";
import { userAPI } from "api";
import { getTaskData } from "api/taskStatus";

const UserPage = () => {
  const [userList, setUserList] = useState([]);
  const [selectUser, setSelectUser] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const { setTitle, setButtons } = useHeader();
  useEffect(() => {
    setTitle("USER");
    setButtons(
      <ActionPanel userLength={userList.length} selectUser={selectUser} />
    );
  }, [setTitle, setButtons, userList.length, selectUser]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const userList = (await getTaskData(userAPI.users)).result.data;
      const result = await Promise.all(
        userList.map(async (user) => {
          const res = await userAPI.getUser(user);
          return res.data.data;
        })
      );

      setUserList(result);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Container>
      <Table
        tags={[
          { name: "name", type: "text", width: "100px" },
          { name: "displayName", type: "text", width: "10%" },
          { name: "ou", type: "text", width: "10%" },
          { name: "department", type: "text", width: "10%" },
          { name: "instances", type: "mult", width: "60%" },
        ]}
        data={userList}
        isCheck={true}
        setCheckData={setSelectUser}
        loading={isLoading}
      />
    </Container>
  );
};

export default UserPage;
